<template>
<div class="chapter">
<div class="inner_page">
<h1>Making Good for Muley</h1>
<h3 class="sigil_not_in_toc">&amp;</h3>
<h2 class="sigil_not_in_toc">Shepherds For Science</h2>
<h2 class="sigil_not_in_toc">W. C. Tuttle</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?5f801b82